// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollContributionsSummaryRecordDto } from './IPayrollContributionsSummaryRecordDto';
import {
    IPayrollContributionsSummaryRecordDtoFromJSON,
    IPayrollContributionsSummaryRecordDtoFromJSONTyped,
    IPayrollContributionsSummaryRecordDtoToJSON,
    IPayrollContributionsSummaryRecordDtoToJSONTyped,
} from './IPayrollContributionsSummaryRecordDto';
import type { IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto } from './IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto';
import {
    IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoPayrollContributionsSummaryRecordDto
 */
export interface IReportSummaryDtoPayrollContributionsSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoPayrollContributionsSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IPayrollContributionsSummaryRecordDto>}
     * @memberof IReportSummaryDtoPayrollContributionsSummaryRecordDto
     */
    employer_records?: Array<IPayrollContributionsSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto>}
     * @memberof IReportSummaryDtoPayrollContributionsSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoPayrollContributionsSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoPayrollContributionsSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoPayrollContributionsSummaryRecordDto(value: object): value is IReportSummaryDtoPayrollContributionsSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoPayrollContributionsSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoPayrollContributionsSummaryRecordDto {
    return IReportSummaryDtoPayrollContributionsSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoPayrollContributionsSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoPayrollContributionsSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IPayrollContributionsSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoPayrollContributionsSummaryRecordDtoToJSON(json: any): IReportSummaryDtoPayrollContributionsSummaryRecordDto {
    return IReportSummaryDtoPayrollContributionsSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoPayrollContributionsSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoPayrollContributionsSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IPayrollContributionsSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoPayrollContributionsSummaryRecordDtoToJSON)),
    };
}

